/* eslint-disable import/extensions */
import _ from '@lodash';
import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';
import { Button } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { determineEditableAccess } from 'modules/ui/editform/EditFormUtils';
import ComponentMassSomethingDialog from './ComponentMassSomethingDialog';
import ComponentMassSomethingDialogLegacy from './ComponentMassSomethingDialogLegacy';

const asObject = value => (value && typeof value === 'object' && !Array.isArray(value) ? value : {});

const combineMinMaxValues = (value, minValue, maxValue) => {
	const values = asObject(value);
	const minValues = asObject(minValue);
	const maxValues = asObject(maxValue);
	const keys = [...new Set([...Object.keys(values), ...Object.keys(minValues), ...Object.keys(maxValues)])];

	return keys.reduce((result, key) => {
		result[key] = {
			value: values[key] ?? null,
			min_value: minValues[key] ?? null,
			max_value: maxValues[key] ?? null
		};
		return result;
	}, {});
};

const splitMinMaxValues = value => {
	const values = {};
	const minValues = {};
	const maxValues = {};

	Object.keys(asObject(value)).forEach(key => {
		const item = asObject(value[key]);
		values[key] = item.value ?? null;
		minValues[key] = item.min_value ?? null;
		maxValues[key] = item.max_value ?? null;
	});

	return {
		value: values,
		minValue: minValues,
		maxValue: maxValues
	};
};

function EditFormComponentMassSomethingField(props) {
	const methods = useFormContext();
	const { value, onChange } = props.field;
	const [nameItems, setNameItems] = useState(null);
	const [openDialog, setOpenDialog] = useState(false);
	const [readOnly, setReadOnly] = useState(determineEditableAccess(props.config, props.fieldConfig, props.fieldPrefix));
	const { compact = false } = props;
	const { minValueField, maxValueField } = props.fieldConfig;
	const usesSeparateMinMaxFields = props.fieldConfig.type === 'MIN_MAX'
		&& minValueField && maxValueField;

	useEffect(() => {
		console.log('EditFormComponentMassSomethingField -> legacy: ' + props.fieldConfig.legacy || false);
	}, []);

	useEffect(() => {
		if (_.isFunction(props.fieldConfig.onChange)) props.fieldConfig.onChange(value, props.field, methods);
	}, [value]);

	const getDialogValue = () => {
		if (!usesSeparateMinMaxFields) return value;

		return combineMinMaxValues(
			value,
			methods.getValues(`${props.fieldPrefix}${minValueField}`),
			methods.getValues(`${props.fieldPrefix}${maxValueField}`)
		);
	};

	const handleSave = result => {
		if (usesSeparateMinMaxFields) {
			const values = splitMinMaxValues(result);
			methods.setValue(`${props.fieldPrefix}${minValueField}`, values.minValue, { shouldDirty: true, shouldValidate: true });
			methods.setValue(`${props.fieldPrefix}${maxValueField}`, values.maxValue, { shouldDirty: true, shouldValidate: true });
			onChange(values.value);
		} else {
			onChange(result);
		}
		setOpenDialog(false);
	};

	const handleOpen = () => {
		if (props.fieldConfig.enumByField) {
			const dto = methods.getValues(props.fieldConfig.enumByField);
			console.log(dto);
			const _nameItems = [];
			if (_.isArray(dto)) {
				dto.forEach(d => {
					_nameItems.push({
						label: d.name,
						value: d.name
					});
				});
				setNameItems(_nameItems);
			}
		}
		setOpenDialog(true);
	};

	return (
		<div className={clsx(compact ? 'flex items-center px-8' : 'flex items-center px-8 mt-8 mb-16', props.fieldConfig.className)}>

			<Button variant="contained" color="primary" className="w-full" onClick={() => handleOpen()}>Open</Button>

			{openDialog && <>

				{props.fieldConfig.legacy ?

					<ComponentMassSomethingDialogLegacy
						fieldPrefix={props.fieldPrefix}
						loadValueFrom={props.fieldConfig.loadValueFrom}
						loadValueMultiplier={props.fieldConfig.loadValueMultiplier}
						value={value}
						nameItems={nameItems}
						onCancel={() => setOpenDialog(false)}
						onSave={handleSave} />

					:

					<ComponentMassSomethingDialog
						fieldPrefix={props.fieldPrefix}
						loadValueFrom={props.fieldConfig.loadValueFrom}
						loadValueMultiplier={props.fieldConfig.loadValueMultiplier}
						disableCopyPaste={props.fieldConfig.disableCopyPaste}
						value={getDialogValue()}
						nameItems={nameItems}
						type={props.fieldConfig.type}
						onCancel={() => setOpenDialog(false)}
						onSave={handleSave} />

				}
			</>}

		</div>
	);
}

export default EditFormComponentMassSomethingField;
